var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLayoutTwo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1611 19.62H6.96106C6.37564 19.62 5.90106 20.0946 5.90106 20.68V25.98C5.90106 26.5654 6.37564 27.04 6.96106 27.04H28.1611C28.7465 27.04 29.2211 26.5654 29.2211 25.98V20.68C29.2211 20.0946 28.7465 19.62 28.1611 19.62Z",
    stroke: "#DDDEE4",
    strokeWidth: 2.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1611 7.96045H6.96106C6.37564 7.96045 5.90106 8.43503 5.90106 9.02045V14.3204C5.90106 14.9059 6.37564 15.3804 6.96106 15.3804H28.1611C28.7465 15.3804 29.2211 14.9059 29.2211 14.3204V9.02045C29.2211 8.43503 28.7465 7.96045 28.1611 7.96045Z",
    stroke: "#DDDEE4",
    strokeWidth: 2.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayoutTwo);
export default __webpack_public_path__ + "static/media/layout-two.c551481d1c7d123d0c4484b57449e1bb.svg";
export { ForwardRef as ReactComponent };